import React from "react";
import { RightCollapseIcon } from "../../../Static/icons/iconshere";

const DynamicModuleTable = ({ children, isCollapsed }) => {
  return (
    <div className="tableParent hidden">
      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Object</th>
            <th scope="col" className="text-center">
              Animation State
            </th>
            <th scope="col" className="text-center">
              Animation Float Value
            </th>
            <th scope="col" className="text-center">
              Is Highlight
            </th>
            <th scope="col" className="text-center">
              Action
            </th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export default DynamicModuleTable;
